
// Inventory Items
export const ITEM_TYPE_BATCH = "batch";
export const ITEM_TYPE_BUNDLE = "bundle";
export const ITEM_TYPE_INVENTORY = "inventory";
export const ITEM_TYPE_SERIALIZED = "serialized";
export const ITEM_TYPE_MATRIX = "matrix";

// Non-Inventory Items
export const ITEM_TYPE_SERVICE = "service";
export const ITEM_TYPE_NONINVENTORY = "noninventory";
export const ITEM_TYPE_SHIPPING = "shipping";
export const ITEM_TYPE_GIFTCERTIFICATE = "giftcertificate";
export const ITEM_TYPE_COUPON = "coupon";

export const ITEM_TYPE_LOYALTY = "loyalty";
export const ITEM_TYPE_DISCOUNT = "discount";
export const ITEM_TYPE_PROMOTION = "promotion";

export const ITEM_TYPE_PAYMENT_SURCHARGE = "payment_surcharge";
export const ITEM_TYPE_SERVICE_CHARGE = "service_charge";
export const ITEM_TYPE_GRATUITY = "gratuity";

// Used for wether to look for default item location or not
export const ITEM_TYPE_GROUP_INVENTORY = [ ITEM_TYPE_INVENTORY, ITEM_TYPE_SERIALIZED, ITEM_TYPE_BATCH, ITEM_TYPE_BUNDLE ];
export const ITEM_TYPE_GROUP_NONINVENTORY = [ ITEM_TYPE_COUPON, ITEM_TYPE_LOYALTY, ITEM_TYPE_SERVICE, ITEM_TYPE_SHIPPING, ITEM_TYPE_DISCOUNT, ITEM_TYPE_PROMOTION, ITEM_TYPE_NONINVENTORY, ITEM_TYPE_GIFTCERTIFICATE ];

// use for promotion triggers criteria
export const ITEM_TYPE_PROMO_CATEGORY_NAME_ITEM_LIST = [ ITEM_TYPE_INVENTORY, ITEM_TYPE_NONINVENTORY, ITEM_TYPE_SHIPPING, ITEM_TYPE_SERIALIZED, ITEM_TYPE_BATCH, ITEM_TYPE_SERVICE, ITEM_TYPE_BUNDLE, ITEM_TYPE_GIFTCERTIFICATE, ITEM_TYPE_LOYALTY];

export const ITEM_TYPE_WITH_NO_PRICEBOOK = [ ITEM_TYPE_DISCOUNT, ITEM_TYPE_PROMOTION, ITEM_TYPE_PAYMENT_SURCHARGE, ITEM_TYPE_SERVICE_CHARGE, ITEM_TYPE_GRATUITY];
export const ITEM_TYPE_WITH_PRICEBOOK = [ ITEM_TYPE_BATCH, ITEM_TYPE_BUNDLE, ITEM_TYPE_INVENTORY, ITEM_TYPE_SERIALIZED, ITEM_TYPE_MATRIX, ITEM_TYPE_SERVICE, ITEM_TYPE_NONINVENTORY, ITEM_TYPE_SHIPPING, ITEM_TYPE_GIFTCERTIFICATE, ITEM_TYPE_COUPON, ITEM_TYPE_LOYALTY];

export const ITEM_TYPE_FOR_CONSIGNMENT_FIELD = [ ITEM_TYPE_BATCH, ITEM_TYPE_BUNDLE, ITEM_TYPE_INVENTORY, ITEM_TYPE_SERIALIZED, ITEM_TYPE_MATRIX ];
export const ITEM_TYPE_FOR_DIMENSION_FIELD =   [ ITEM_TYPE_BATCH, ITEM_TYPE_BUNDLE, ITEM_TYPE_INVENTORY, ITEM_TYPE_SERIALIZED, ITEM_TYPE_MATRIX ];
export const ITEM_TYPE_FOR_WEIGHT_FIELD =      [ ITEM_TYPE_BATCH, ITEM_TYPE_BUNDLE, ITEM_TYPE_INVENTORY, ITEM_TYPE_SERIALIZED, ITEM_TYPE_MATRIX ];
export const ITEM_TYPE_FOR_FACET_FIELD = [ ITEM_TYPE_BATCH, ITEM_TYPE_BUNDLE, ITEM_TYPE_INVENTORY, ITEM_TYPE_SERIALIZED, ITEM_TYPE_MATRIX, ITEM_TYPE_SERVICE, ITEM_TYPE_GIFTCERTIFICATE, ITEM_TYPE_NONINVENTORY ];
export const ITEM_TYPE_FOR_ISMANUALPROMO_FIELD = [ ITEM_TYPE_PROMOTION ];
